import React, { useState, useEffect } from 'react';
import { DemoRequestModal } from './landing/DemoRequestModal';
import { ConvNav } from './landing/ConvNav';
import { ConvHero } from './landing/ConvHero';
import { ConvProblem } from './landing/ConvProblem';
import { ConvSolution } from './landing/ConvSolution';
import { ConvReseauProfile } from './landing/ConvReseauProfile';
import { ConvCompatBand } from './landing/ConvCompatBand';
import { ConvCopilots } from './landing/ConvCopilots';
import { ConvMultiAgenceProvidence } from './landing/ConvMultiAgenceProvidence';
import { ConvSellerJourney } from './landing/ConvSellerJourney';
import { ConvNetworkLoop } from './landing/ConvNetworkLoop';
import { ConvInterfaces } from './landing/ConvInterfaces';
import { ConvProofs } from './landing/ConvProofs';
import { ConvDiscoverPlan } from './landing/ConvDiscoverPlan';
import { ConvFAQ } from './landing/ConvFAQ';
import { ConvFinalCTA } from './landing/ConvFinalCTA';
import { ConvFooter } from './landing/ConvFooter';
import { ConvNarrative } from './landing/ConvNarrative';
import { StickyConversionBar } from './landing/StickyConversionBar';
import { FloatingCallbackWidget } from './landing/FloatingCallbackWidget';

/**
 * LandingPage — Iter169 — Conversion vers la demande entrante.
 *
 * Stratégie commerciale : pas d'affichage de tarif public sur la landing.
 * L'objectif unique de la page est de maximiser les demandes de
 * démonstration. Le prix est révélé en RDV après qualification.
 *
 * Ordre des sections :
 *
 *   1.  Hero                  — Promesse en 1s + visuel produit vivant + CTA
 *   2.  ConvNarrative         — Comment ça marche en 3 étapes
 *   3.  CompatBand            — Réassurance technique (compatible CRM)
 *   4.  Problem               — Frustrations dirigeant (sans la théorie du
 *                                coiffeur retirée Iter169 — gardée pour
 *                                argumentation commerciale vive voix)
 *   5.  Solution              — Réponse Homly : les 2 moteurs
 *   6.  ReseauProfile         — Démo moteur Réseau côté visible
 *   7.  Copilots              — Démo moteur Cockpit (4 IA)
 *   8.  Interfaces            — Mockups produit
 *   9.  NetworkLoop           — La boucle vertueuse
 *   10. MultiAgenceProvidence — Upsell groupes / réseaux
 *   11. SellerJourney         — Côté vendeur (preuve d'écosystème)
 *   12. Proofs                — Preuves sociales
 *   13. ConvDiscoverPlan      — "Discutons de votre besoin" (remplace
 *                                ConvPricing — pas de prix public)
 *   14. FAQ                   — Lever les dernières objections
 *   15. FinalCTA              — Bascule conversion
 */
export default function LandingPage() {
    const [showDemoModal, setShowDemoModal] = useState(
        () => new URLSearchParams(window.location.search).get('demo') === 'true'
    );

    const openDemoModal = () => setShowDemoModal(true);
    const closeDemoModal = () => setShowDemoModal(false);

    useEffect(() => {
        // Force dark theme on the landing
        document.documentElement.classList.add('dark');
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) metaThemeColor.setAttribute('content', '#050308');
    }, []);

    return (
        <div className="min-h-screen bg-[#050308] text-white antialiased" data-testid="landing-page">
            <StickyConversionBar onDemoClick={openDemoModal} />
            <ConvNav onDemoClick={openDemoModal} />
            <main>
                <ConvHero onDemoClick={openDemoModal} />
                <ConvNarrative />
                <ConvCompatBand />
                <ConvProblem onDemoClick={openDemoModal} />
                <ConvSolution />
                <ConvReseauProfile />
                <ConvCopilots />
                <ConvInterfaces />
                <ConvNetworkLoop />
                <ConvMultiAgenceProvidence onDemoClick={openDemoModal} />
                <ConvSellerJourney />
                <ConvProofs />
                <ConvDiscoverPlan onDemoClick={openDemoModal} />
                <ConvFAQ />
                <ConvFinalCTA onDemoClick={openDemoModal} />
            </main>
            <ConvFooter />
            <FloatingCallbackWidget />
            <DemoRequestModal isOpen={showDemoModal} onClose={closeDemoModal} />
        </div>
    );
}
